import { useState } from "react";
import { toast } from "sonner";
import { Archive, FileSpreadsheet, Loader2, Trash2 } from "lucide-react";
import { api, errMsg, downloadFile } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { ConfirmDialog } from "./ConfirmDialog";

export const DataTab = () => {
  const { isAdmin, can } = useAuth();
  const [busy, setBusy] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [month, setMonth] = useState(new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Kolkata" }).format(new Date()).slice(0, 7));

  const run = (key, fn) => async () => {
    setBusy(key);
    try {
      await fn();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy("");
    }
  };
  const today = new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Kolkata" }).format(new Date());
  const spin = (k, Icon) => (busy === k ? <Loader2 size={18} className="animate-spin" /> : <Icon size={18} />);

  const deleteSample = run("sample", async () => {
    setConfirm(false);
    const { data } = await api.delete("/sample-data");
    toast.success(`Deleted ${data.pos_deleted} sample PO(s) and ${data.vendors_deleted} sample vendor(s)`);
  });

  return (
    <div className="space-y-3" data-testid="data-tab">
      <div className="panel space-y-3 p-4">
        <h3 className="font-heading font-bold">Exports</h3>
        {can("export_all") && <button className="btn btn-outline w-full" disabled={!!busy} onClick={run("xls", () => downloadFile("/export/excel", "PO-Register.xlsx"))} data-testid="data-excel-btn">
          {spin("xls", FileSpreadsheet)} Download Excel (all records)
        </button>}
        {isAdmin && (
          <>
            <button className="btn btn-outline w-full" disabled={!!busy} onClick={run("zip", () => downloadFile("/export/backup", `manmoda-po-backup-${today}.zip`))} data-testid="data-backup-btn">
              {spin("zip", Archive)} Download full backup (data + photos)
            </button>
            <p className="text-xs text-muted-foreground">The backup is a ZIP with all records (JSON), the Excel register and every item photo.</p>
          </>
        )}
      </div>
      {can("export_month") && <div className="panel space-y-3 p-4" data-testid="month-export">
        <h3 className="font-heading font-bold">Sales & stock for one month</h3>
        <p className="text-sm text-muted-foreground">For your accountant: a month summary by location and shirt, every sale, and day-wise stock movement.</p>
        <input type="month" className="field" value={month} onChange={(e) => setMonth(e.target.value)} data-testid="month-export-input" />
        <button className="btn btn-primary w-full" disabled={!!busy || !month} onClick={run("month", () => downloadFile(`/export/stock-month?month=${month}`, `Sales-Stock-${month}.xlsx`))} data-testid="month-export-btn">
          {spin("month", FileSpreadsheet)} Download month Excel
        </button>
      </div>}
      {isAdmin && (
        <div className="panel space-y-3 p-4">
          <h3 className="font-heading font-bold">Sample data</h3>
          <p className="text-sm text-muted-foreground">Removes the vendor and PO marked "Sample". Your own data is not touched.</p>
          <button className="btn btn-outline btn-ghost-danger w-full" disabled={!!busy} onClick={() => setConfirm(true)} data-testid="delete-sample-btn">
            {spin("sample", Trash2)} Delete sample data
          </button>
        </div>
      )}
      <ConfirmDialog open={confirm} onCancel={() => setConfirm(false)} onConfirm={deleteSample} title="Delete sample data?"
        body="The sample vendor and sample PO will be removed permanently." />
    </div>
  );
};
